import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';
import './DigDeeper.css';

const styles = ["balanced", "aggressive", "funny", "kids"];

const DigDeeper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const topic = location.state?.topic;

  const [selectedStyle, setSelectedStyle] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const handleStyleSelect = async (style) => {
    setSelectedStyle(style);
    setLoading(true);
    try {
      const res = await axios.post('/debate', {
        topic,
        style
      });
      setResponse(res.data);
    } catch (err) {
      setResponse({ error: 'Failed to create debate.' });
    }
    setLoading(false);
  };

  const handleDebateClick = () => {
    navigate('/debate', { state: { topic, selectedStyle } });
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <h3>Loading...</h3>
      </div>
    );
  }

  if (response && response.choices && response.choices[0]) {
    return (
      <div className="position-relative d-flex flex-column justify-content-between align-items-center vh-100 p-4">
        {/* Back button */}
        <button
          className="btn btn-sm btn-success rounded-circle position-absolute"
          style={{ top: 16, left: 16, zIndex: 2, width: 36, height: 36, padding: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          onClick={() => navigate(-1)}
        >
          ←
        </button>
        {/* Citations icon with tooltip */}
        {response.citations && response.citations.length > 0 && (
          <div
            className="position-absolute"
            style={{ top: 16, right: 30, zIndex: 2 }}
            onMouseEnter={() => setShowTooltip(true)}
            onMouseLeave={() => setShowTooltip(false)}
          >
            <button
              className="btn btn-success btn-sm rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: 36, height: 36, padding: 0 }}
              title="Show Citations"
              type="button"
            >
              <span style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>i</span>
            </button>
            {showTooltip && (
              <div id="citation-tooltip">
                <strong>Citations</strong>
                <ul className="mb-0" style={{ paddingLeft: 18 }}>
                  {response.citations.map((cite, idx) => (
                    <li key={idx} style={{ wordBreak: 'break-all' }}>
                      <a href={cite} target="_blank" rel="noopener noreferrer">{cite}</a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        )}
        <div className="container" style={{ overflowY: 'auto', flex: 1 }}>
          <div className="bg-light p-3 rounded w-100" style={{ minHeight: '60vh' }}>
            <ReactMarkdown>
              {response.choices[0].message.content}
            </ReactMarkdown>
          </div>
        </div>
        {/* Debate this button */}
        <button className="btn btn-success w-50 mt-3" onClick={handleDebateClick}>
          Debate this
        </button>
      </div>
    );
  }

  return (
    <div className="d-flex flex-column justify-content-center align-items-center vh-100">
      {/* Back button */}
      <button
        className="btn btn-sm btn-rounded btn-success position-absolute rounded-circle"
        style={{ top: 16, left: 16, zIndex: 2 }}
        onClick={() => navigate(-1)}
      >
        ←
      </button>
      <h2>Pick a Debate Style</h2>
      <p>Topic: <strong>{topic}</strong></p>
      <div className="d-flex flex-wrap gap-3 mt-4">
        {styles.map(style => (
          <button
            key={style}
            className="btn btn-outline-success"
            onClick={() => handleStyleSelect(style)}
          >
            {style.charAt(0).toUpperCase() + style.slice(1)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default DigDeeper;